/*
 * @Author: Hyman Choi
 * @Date: 2021-03-08 16:50:49
 * @LastEditTime: 2021-03-09 08:54:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.Web\src\api\versionManagement.js
 */
import request from '@/utils/request'
import config from '@/utils/config'

/**
 *
 *
 * @param {*} params
 */
export function getAppVersionList(params) {
  return request({
    url: config.API_ROOT + '/Api/V1/AdminVersions/AppVersionList',
    method: 'get',
    params
  })
}

/**
 *
 *
 * @param {*} params
 */
export function getAppVersion(params) {
  return request({
    url: config.API_ROOT + '/Api/V1/AdminVersions/One',
    method: 'get',
    params
  })
}

/**
 *
 *
 * @param {*} data
 */
export function editAppVersion(data) {
  return request({
    url: config.API_ROOT + '/Api/V1/AdminVersions/Update',
    method: 'post',
    data
  })
}
